import $ from 'jquery';

function serializerFormToJson( formObject){
	var obj = {};
	var a = $(formObject).serializeArray();
	$.each(a, function() {
		let newName = this.name;
		if(typeof obj[this.name] !== 'undefined') {
			if(!obj[newName].push) {
				obj[newName] = [obj[newName]];
			}
			obj[newName].push(this.value || '');
		} else{
			obj[newName] = this.value || '';
		}
	});
	return obj;
}

function mapFormObjecToCRM( obj){
	var mappedObj = {};
	// List of attributes not used in an AEM Form
	// mappedObj.lineOfBusiness = (obj. || '');
	// mappedObj.sourceRefID = (obj. || '');
	// mappedObj.addressCity = (obj. || '');
	// mappedObj.addressCountry = (obj. || '');
	// mappedObj.addressLine1 = (obj. || '');
	// mappedObj.addressLine2 = (obj. || '');
	// mappedObj.addressPostalCode = (obj. || '');
	// mappedObj.addressStateOrProvince = (obj. || '');
	// mappedObj.bestTimeToContact = (obj. || '');
	// mappedObj.birthDate = (obj. || '');
	// mappedObj.employeeNumber = (obj. || '');
	// mappedObj.employerId = (obj. || '');
	// mappedObj.genderCode = (obj. || '');
	// mappedObj.primaryGoal = (obj. || '');
	// mappedObj.referringContactId = (obj. || '');
	// mappedObj.underEighteen = (obj. || '');
	// mappedObj.referringMemberId = (obj. || '');
	// mappedObj.registrationCode = (obj. || '');
	// mappedObj.leadType=(obj. || '');
	// mappedObj.telephone1 = (obj. || '');
	// mappedObj.memberId = (obj. || '');
	// mappedObj.requestType = (obj. || '');


	mappedObj.clubStatus = (obj.ltf_clubstatus || '');
	mappedObj.addressLatitude = window.currentLatitude;
	mappedObj.addressLongitude = window.currentLongitude;
	mappedObj.birthYear = (obj.ltf_birthyear || '');
	mappedObj.channel = ('AEM');
	mappedObj.communicationConsent = (obj.ltf_communicationconsent || '');
	mappedObj.consentDateAndTime = (obj.ltf_consentdatetime || '');
	mappedObj.consentIPAddress = (obj.ltf_consentipaddress || '');
	mappedObj.consentText = (obj.ltf_consenttext || '');
	mappedObj.currentMember = (obj.ltf_currentmember || '');
	mappedObj.dcmp = (obj.ltf_dcmp || '');
	mappedObj.description = (obj.description || '');
	mappedObj.device = (obj.ltf_device || '');
	mappedObj.emailAddress = (obj.ltf_emailaddress1 || '');
	mappedObj.emailTemplate = (obj.ltf_emailtemplate || '');
	mappedObj.firstName = (obj.ltf_firstname || '');
	mappedObj.gcId = (obj.ltf_gcid || '');
	mappedObj.gcLId = (obj.ltf_gclid || '');
	mappedObj.group = (obj.ltf_group || '');
	mappedObj.inquiryType = (obj.ltf_inquirytype || '');
	mappedObj.leadType = (obj.ltf_inquirysource || '');
	mappedObj.interests = (obj.ltf_interests || '');
	mappedObj.keyWords = (obj.ltf_keywords || '');
	mappedObj.landingPage = (obj.ltf_landingpage || '');
	mappedObj.lastName = (obj.ltf_lastname || '');
	mappedObj.clubType = (obj.ltf_clubtype || '');
	mappedObj.membershipInfoRequested = (obj.ltf_membershipinforequested || '');
	mappedObj.mmsClubId = (obj.ltf_mmsclubid || '');
	mappedObj.operatingSystem = (obj.ltf_operatingsystem || '');
	mappedObj.referringDomain = (obj.ltf_referringdomain || '');
	mappedObj.referringPage = (obj.ltf_referringpage || '');
	mappedObj.subject = (obj.subject || '');
	mappedObj.telephone2 = (obj.ltf_telephone2 || '');
	mappedObj.utmAudience = (obj.ltf_utmaudience || '');
	mappedObj.utmCampaign = (obj.ltf_utmcampaign || '');
	mappedObj.utmContent = (obj.ltf_utmcontent || '');
	mappedObj.utmImage = (obj.ltf_utmimage || '');
	mappedObj.utmMedium = (obj.ltf_utmmedium || '');
	mappedObj.utmSource = (obj.ltf_utmsource || '');
	mappedObj.utmTerm = (obj.ltf_utmterm || '');
	mappedObj.visitCount = (obj.ltf_visitcount || '');
	mappedObj.visitorId = (obj.ltf_visitorid || '');
	return mappedObj;
}

var returnVal = {
	serializerFormToJson: serializerFormToJson,
	mapFormObjecToCRM: mapFormObjecToCRM
};

export default returnVal;
